import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { ReactNode } from 'react';

import { CompensationStatus, Namespace } from 'enums';
import { Cross, Ok, RequestUpdate } from 'icons';

import styles from './StatusActions.module.scss';

interface Props {
  readonly currentStatus?: CompensationStatus;
  readonly onAction: (status: CompensationStatus) => void;
}

const statusIcons: Record<string, ReactNode> = {
  [CompensationStatus.Approved]: <Ok />,
  [CompensationStatus.Rejected]: <Cross />,
  [CompensationStatus.UpdateRequired]: <RequestUpdate />,
};

export const StatusActions = ({ currentStatus, onAction }: Props) => {
  const { t } = useTranslation(Namespace.StatusActions, { keyPrefix: Namespace.Short });

  return (
    <div className={styles.buttonsContainer}>
      {[CompensationStatus.Approved, CompensationStatus.Rejected, CompensationStatus.UpdateRequired]
        .filter((status) => status !== currentStatus)
        .map((status) => (
          <Button key={status} onClick={() => onAction(status)} icon={statusIcons[status]}>
            {t(status)}
          </Button>
        ))}
    </div>
  );
};
